import { produce } from 'immer'
import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { QRCode } from 'react-qrcode-logo'

import { Alert, Button, H4, Intent, SwitchCard } from '@blueprintjs/core'

import styles from './ProfileQrButton.module.scss'

export default ({
    profileId,
    canDisplaySwitch = false,
}: {
    profileId: string,
    canDisplaySwitch?: boolean,
}) => {
    const { t } = useTranslation()

    const [state, setState] = useState({
        isQrCodeOpen: false,
        isSwitchChecked: true,
    })

    const displayQrCode = useCallback(() =>
        setState(produce(draft => {
            draft.isQrCodeOpen = true
        })), [])

    const dismissQrCode = useCallback(() =>
        setState(produce(draft => {
            draft.isQrCodeOpen = false
        })), [])

    const isAutoDownloadEnabled = state.isSwitchChecked && canDisplaySwitch
    const qrCodeUrl = `${window.location.origin}/profiles/${profileId}${isAutoDownloadEnabled ? '?download' : ''}`


    return <>
        <Alert
            isOpen={state.isQrCodeOpen}
            canEscapeKeyCancel
            canOutsideClickCancel
            confirmButtonText={t('profile.qr.alert.closeButton.label')}
            cancelButtonText=''
            onConfirm={dismissQrCode}
            onCancel={dismissQrCode}>
            <div className={styles.container}>
                <H4 className={styles.title}>
                    {t('profile.qr.alert.title')}
                </H4>
                <QRCode
                    value={qrCodeUrl}
                    quietZone={24}
                    size={1024}
                    style={{
                        width: '80vw',
                        height: '80vw',
                        maxWidth: '320px',
                        maxHeight: '320px',
                    }} />
                <p className={styles.message}>
                    {t('profile.qr.alert.message')}
                </p>
                {canDisplaySwitch &&
                    <SwitchCard
                        className={styles.switch}
                        label={t('profile.qr.alert.switch.label')}
                        checked={state.isSwitchChecked}
                        onChange={e => setState(produce(draft => {
                            draft.isSwitchChecked = e.target.checked
                        }))}
                        compact />
                }
            </div>
        </Alert>

        <Button
            text={t('profile.qr.displayButton.label')}
            intent={Intent.NONE}
            onClick={displayQrCode} />
    </>
}
